import type { Session } from "./activeSession"
import { revokeAccessToken } from "./revokeAccessToken"
import { removeSession } from "./storage"

export const revokeSession = async (session: Session) => {
  const removedSessions = await removeSession(session)
  await Promise.all(removedSessions.map(revokeAccessToken))
}
